import React, { useState, useEffect } from 'react';
import customFetch from "./apicall/api";
import { useParams } from 'react-router-dom';
import styles from "../assets/css/payment_response_gi.module.css";

const PaymentResponseGI= () => {
  const [paymentDetails, setPaymentDetails] = useState({
    status: 'loading',
    proposalId: 'N/A',
    transactionId: 'N/A',
    error_message: '',
    error_flag: ''
  });

  const {proposalId} = useParams();
  
  const isSuccessful = paymentDetails.status === 'success';

  useEffect(() => {
    document.title = "Payment Status";
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    
    const error_message = params.get('ERRMSG');
    const error_flag = atob(params.get('ERRFLG'));
    
    let status = "failure"
    if (error_message !== "" || error_flag !== "") {
      status = 'failure';
    } else {
      status = 'success';
    }
    
    const proposalId = atob(params.get('PNO')) || 'N/A';
    const transactionId = atob(params.get('TXNREFNO')) || 'N/A';

    const url_query_object = Object.fromEntries(params.entries());
    
    // PNO=&
    // TXNREFNO=NDAzOTkzNzE1NTM1MDY2MjY3&UWC=&
    // ERRFLG=ZmFpbHVyZQ==&
    // ERRMSG=Bank%20was%20unable%20to%20authenticate.&siforCreditcard=&
    // receiptNum=&
    // if the above keys are not present in params don't callenque
    // 2121109813132?PNO=&TXNREFNO=NDAzOTkzNzE1NTM1MDg0ODE2&UWC=&ERRFLG=ZmFpbHVyZQ==&ERRMSG=Bank%20failed%20to%20authenticate%20the%20customer&siforCreditcard=&receiptNum=&proposalNum=
    // 2121109813132?PNO=MTMwMDg5MjM=&TXNREFNO=NDAzOTkzNzE1NTM1MDg0ODQx&UWC=SU5GT1JDRQ==&ERRFLG=&ERRMSG=&siforCreditcard=0&receiptNum=&proposalNum=MjEyMTEwOTgxMzEzMg==
    const requiredKeys = ["PNO", "TXNREFNO", "UWC", "proposalNum", "ERRMSG", "receiptNum"]
     
    if (requiredKeys.every(key => params.has(key))){
      // Prevent duplicate enqueuing by checking localStorage for transactionId
      const storedTxnId = localStorage.getItem('enqueued_txn_id');
      if (storedTxnId === transactionId && transactionId !== 'N/A') {
        console.log("Transaction already enqueued, skipping.");
      } else {
        console.log("recording the payment response")
        localStorage.setItem('enqueued_txn_id', transactionId);
        callenque(url_query_object, status);
      }
    } 
    
    setPaymentDetails({
      status,
      proposalId,
      transactionId,
      error_message,
      error_flag
    });
  }, []); 

  const callenque = (url_query_object,event) => {
    let _body = {
      payload: {
        proposalId: proposalId,
        response: url_query_object,
        vendor_name: "CareHealth",
        event: event,
      },
      topic: "Processed",
    };
    customFetch(process.env.REACT_APP_URL + "/enque/", {
      method: "POST",
      headers: {
        "api-token": localStorage.getItem("api_token"),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(_body),
    })
      .then((res) => {
        if (res.headers.get("api_code") > 0) {
          this.setState({
            isErrOpen: true,
            api_error_message: res.headers.get("api_error_message"),
            isSpin: false,
          });
        }
        return res.json();
      })
      .then((json) => {
        console.log(json);
      })
      .catch((error) => console.log("error", error));
  };
  
  const statusTitle = isSuccessful ? 'Payment Successful' : 'Payment Failed';
  const statusColorClass = isSuccessful ? 'success-color' : 'failure-color';
  const textClass = isSuccessful ? 'text-success' : 'text-failure';

  const icon = isSuccessful 
    ? <svg className={`${styles.statusIcon} ${styles.successIcon}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
    : <svg className={`${styles.statusIcon} ${styles.failureIcon}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>;

  return (
    <div className={styles.container}>

      <div className={styles.contentBlock}>
        <div className={styles.statusHeader}>
          <div className={styles.statusIcon}>
            {icon}
          </div>
          <h1 className={`${styles.title} ${styles[statusColorClass]}`}>{statusTitle}</h1>
          <p>{paymentDetails.error_message}</p>
        </div>

        <div className={styles.detailContainer}>
          <div className={styles.detailItem}>
            <span className={styles.detailLabel}>Proposal Number:</span>
            <span className={`${styles.detailValue} ${styles[textClass]}`}>{proposalId}</span>
          </div>
          <div className={styles.detailItem}>
            <span className={styles.detailLabel}>Payment Status:</span>
            <span className={`${styles.detailValue} ${styles[textClass]}`}>{paymentDetails.status}</span>
          </div>
          {paymentDetails.transactionId !== 'N/A' && (
            <div className={styles.detailItem}>
              <span className={styles.detailLabel}>Transaction ID:</span>
              <span className={`${styles.detailValue} ${styles.textGrayMono}`}>{paymentDetails.transactionId}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};


export default PaymentResponseGI;
